import React, { PureComponent } from "react";
import PageLink from "../../../components/Page/PageLink";
import Footer from "../../../components/Footer/Footer";

class Component_dashboard_line_chart extends PureComponent {
  render() {
    return (
      <div className="row" id="component_dashboard_line_chart">
        <div className="col-md-6">
          <div className="contentLight">
            <section>
              <h2>Dashboard Line Chart</h2>
              <p>
                Dashboard chart components are a great way to give your users
                quick, understandable data. All the dashboard chart components
                use the same structure. So testing different chart types is as
                simple as change that "type" value.
              </p>
              <p>
                Chart components are based on the popular charts.js framework.
                We have created a wrapper around charts.js so you can easily
                feed in Nexoid data. Because of the size and flexibility of
                charts.js we have added JSON string overridden for options and
                dataset options. These give you the ability to access some of
                the deeper functions hidden within charts.js.
              </p>
              <p>
                For more detail, please look at the{" "}
                <PageLink to="https://www.chartjs.org/" text="charts.js" />{" "}
                documentation.
              </p>
              <p>
                The data comes from Nexoid API Search calls. Each data feed has
                its own API call. By default, the charts are set to get the
                total number of records of your query as the displayed result.
              </p>
              <p>
                For a better understanding of API record queries, please look at
                the{" "}
                <PageLink to="API/search_records" text="API Record Search" />{" "}
                document on this site.
              </p>
              <div className="chartImageBox">
                <img
                  className="chartImage"
                  src={"img/example/charts/line.jpg"}
                ></img>
              </div>
              <h3>Compatibility</h3>
              <table style={{ width: "auto" }}>
                <tbody>
                  <tr>
                    <td className="b top">Page</td>
                    <td className="b top">Support</td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Dashboard
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold",
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Record
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold",
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Report
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#D32F2F",
                          fontWeight: "bold",
                        }}
                      >
                        close
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b" style={{ paddingTop: 4 }}>
                      Search
                    </td>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="material-icons"
                        style={{
                          position: "relative",
                          top: 3,
                          fontSize: 24,
                          color: "#388E3C",
                          fontWeight: "bold",
                        }}
                      >
                        done
                      </i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Properties</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">type</td>
                    <td>
                      <i
                        className="material-icons"
                        style={{
                          display: "inline-block",
                          height: 24,
                          position: "relative",
                          top: 6,
                          fontSize: 24,
                          color: "#F57C00",
                        }}
                      >
                        warning
                      </i>{" "}
                      Must be <strong>"dashboard_line_chart"</strong> for the
                      pie chart component.
                      <br />
                      <i>
                        <strong>"dashboard_line_chart"</strong>
                      </i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">data_feed_mode</td>
                    <td>
                      How the queried results will be interpreted. Default is to
                      count the total results returned.
                      <br />
                      <i>"count", "date_histogram"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">data_feed</td>
                    <td>
                      Data feed container object containing each custom data
                      feed. Each data feed object is a charts.js dataset and
                      contains the individual data feeds for each data point.
                      See example and data feed table below.
                      <br />
                      <i>&#123; ... &#125;</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">data_feed_eval</td>
                    <td>
                      The data_feed_eval property allows you to create a
                      JavaScript that Returns via a callback method a charts.js
                      dataset. This can be used for more complex data feeds and
                      supports the interface workflow NL libraries.
                      <br />
                      <i>"callback(null, &#123; ... &#125;)"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">legend</td>
                    <td>
                      Object with quick shortcut settings for the chart.js draw
                      options.lengend object. (see options table below)
                      <br />
                      <i>&#123; ... &#125;</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">options</td>
                    <td>
                      Object with quick shortcut settings for the chart.js draw
                      options object. (see options table below)
                      <br />
                      <i>&#123; ... &#125;</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">options_json</td>
                    <td>
                      A JSON string chart.js draw options override allowing you
                      insert unsupported options. For more details, please
                      review the chart.js options documentation.
                      <br />
                      <i>"&#123; ... &#125;"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">refresh</td>
                    <td>
                      Graph data refresh loop delay in seconds.
                      <br />
                      <i>60 - 86400 default is 300 (5 minutes)</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Legend</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">font_color</td>
                    <td>
                      The HEX or RGBA color of the legend text.
                      <br />
                      <i>"#272727" default is "RGBA(0, 0, 0, 0.87)"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">position</td>
                    <td>
                      Position of the legend compared to the graph. Positions
                      are "top", "left", "right" and "bottom".
                      <br />
                      <i>"top" default is "bottom"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">display</td>
                    <td>
                      Turn the legend on or off.
                      <br />
                      <i>true or false default is true</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Options</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">maintain_aspect_ratio</td>
                    <td>
                      Maintain the original canvas aspect ratio.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">responsive</td>
                    <td>
                      Resizes the chart canvas when its container does.
                      <br />
                      <i>true, false default is true</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">title_display</td>
                    <td>
                      Turn the title on or off.
                      <br />
                      <i>"true, false default is true"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">title_text</td>
                    <td>
                      The title of the chart.
                      <br />
                      <i>"My chart title" default is "Custom Chart Title"</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Data Feed</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">label</td>
                    <td>
                      Maintain the original canvas aspect ratio.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">responsive</td>
                    <td>
                      Resizes the chart canvas when its container does.
                      <br />
                      <i>true, false default is true</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">order</td>
                    <td>
                      Order that the datasets will appear in the group.
                      <br />
                      <i>1 - 10000 default is the order of the model</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">datasets_json</td>
                    <td>
                      A JSON string chart.js draw dataset options override
                      allowing you insert unsupported dataset options. For more
                      details, please review the chart.js options documentation.
                      <br />
                      <i>"&#123; ... &#125;"</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <h3>Feed</h3>
              <table>
                <tbody>
                  <tr>
                    <td className="b top">Property</td>
                    <td className="b top">Description</td>
                  </tr>
                  <tr>
                    <td className="b">color_background</td>
                    <td>
                      The second color used in the graph.
                      <br />
                      <i>"#4CAF50"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">color_foreground</td>
                    <td>
                      The first color used in the graph.
                      <br />
                      <i>"#388E3C"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">source_url_api</td>
                    <td>
                      The name of the object or table to receive the data from.
                      <br />
                      <i>"incidents"</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">source_url_api_system_object</td>
                    <td>
                      Query a system object like users or keywords.
                      <br />
                      <i>true, false default is false</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">responsive</td>
                    <td>
                      Resizes the chart canvas when its container does.
                      <br />
                      <i>true, false default is true</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">title</td>
                    <td>
                      Name of the data set.
                      <br />
                      <i>"My record set."</i>
                    </td>
                  </tr>
                  <tr>
                    <td className="b">query</td>
                    <td>
                      Data query object using the ElasticSearch syntax. Look at
                      API Record Search for more details.
                      <br />
                      <i>&#123; ... &#125;</i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <Footer
                section={this.props.section}
                article={this.props.article}
                routeParams={this.props.routeParams}
              />
            </section>
          </div>
        </div>
        <div className="col-md-6 darkCol">
          <div className="contentDark">
            <section>
              <h2>Dashboard Line Chart Example</h2>
            </section>
            <section>
              <h3>Example 1: Simple Graph</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"dashboard_line_chart"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_feed_mode"</span>:{" "}
                  <span className="jsonY">"count"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"refresh"</span>:{" "}
                  <span className="jsonP">300</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"options"</span>: <span>&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonG">"responsive"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"maintain_aspect_ratio"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"title_text"</span>:{" "}
                  <span className="jsonY">"Active Vs. Inactive Contact"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"title_display"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div className="i1">
                  <span>&#125;,</span>
                </div>
                <div className="i1">
                  <span className="jsonG">"options_json"</span>:{" "}
                  <span className="jsonY">"&#123;&#125;"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"legend"</span>: <span>&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonG">"font_color"</span>:{" "}
                  <span className="jsonY">"#000000"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"position"</span>:{" "}
                  <span className="jsonY">"bottom"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"display"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div className="i1">
                  <span>&#125;,</span>
                </div>
                <div className="i1">
                  <span className="jsonG">"data_feed"</span>:{" "}
                  <span>&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonG">"my_first_feed"</span>:{" "}
                  <span>&#123;</span>
                </div>
                <div className="i3">
                  <span className="jsonG">"datasets_json"</span>:{" "}
                  <span className="jsonY">
                    "&#123;\"label\": \"Overridden label\"&#125;"
                  </span>
                  ,
                </div>
                <div className="i3">
                  <span className="jsonG">"label"</span>:{" "}
                  <span className="jsonY">"Original Label"</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"feeds"</span>: <span>&#123;</span>
                </div>
                <div className="i4">
                  <span className="jsonG">"inactive"</span>: <span>&#123;</span>
                </div>
                <div className="i5">
                  <span className="jsonG">"title"</span>:{" "}
                  <span className="jsonY">"Inactive Contacts"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"contacts"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"source_url_api_system_object"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"color_foreground"</span>:{" "}
                  <span className="jsonY">"#D32F2F"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"color_background"</span>:{" "}
                  <span className="jsonY">"#D32F2F"</span>,
                </div>

                <div className="i5">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"query"</span>: <span>&#123;</span>
                </div>
                <div className="i6">
                  <span className="jsonG">"bool"</span>: <span>&#123;</span>
                </div>
                <div className="i7">
                  <span className="jsonG">"filter"</span>: <span>&#123;</span>
                </div>
                <div className="i8">
                  <span className="jsonG">"term"</span>: <span>&#123;</span>
                </div>
                <div className="i9">
                  <span className="jsonG">"text_state"</span>:{" "}
                  <span className="jsonY">"inactive"</span>
                </div>
                <div className="i8">
                  <span>&#125;</span>
                </div>
                <div className="i7">
                  <span>&#125;</span>
                </div>
                <div className="i6">
                  <span>&#125;</span>
                </div>
                <div className="i5">
                  <span>&#125;</span>
                </div>
                <div className="i4">
                  <span>&#125;,</span>
                </div>
                <div className="i4">
                  <span className="jsonG">"active"</span>: <span>&#123;</span>
                </div>
                <div className="i5">
                  <span className="jsonG">"title"</span>:{" "}
                  <span className="jsonY">"Active Contacts"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"contacts"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"source_url_api_system_object"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"color_foreground"</span>:{" "}
                  <span className="jsonY">"#43A047"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"color_background"</span>:{" "}
                  <span className="jsonY">"#43A047"</span>,
                </div>

                <div className="i5">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">2</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"query"</span>: <span>&#123;</span>
                </div>
                <div className="i6">
                  <span className="jsonG">"bool"</span>: <span>&#123;</span>
                </div>
                <div className="i7">
                  <span className="jsonG">"filter"</span>: <span>&#123;</span>
                </div>
                <div className="i8">
                  <span className="jsonG">"term"</span>: <span>&#123;</span>
                </div>
                <div className="i9">
                  <span className="jsonG">"text_state"</span>:{" "}
                  <span className="jsonY">"active"</span>
                </div>
                <div className="i8">
                  <span>&#125;</span>
                </div>
                <div className="i7">
                  <span>&#125;</span>
                </div>
                <div className="i6">
                  <span>&#125;</span>
                </div>
                <div className="i5">
                  <span>&#125;</span>
                </div>
                <div className="i4">
                  <span>&#125;</span>
                </div>
                <div className="i3">
                  <span>&#125;</span>
                </div>
                <div className="i2">
                  <span>&#125;</span>
                </div>
                <div className="i1">
                  <span>&#125;</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>

            <section>
              <h3>Example 2: Incidents Created Over Time</h3>
              <div className="darkCode">
                <div>&#123;</div>
                <strong>
                  <div className="i1">
                    <span className="jsonG">"type"</span>:{" "}
                    <span className="jsonY">"dashboard_line_chart"</span>,
                  </div>
                </strong>
                <div className="i1">
                  <span className="jsonG">"data_feed_mode"</span>:{" "}
                  <span className="jsonY">"date_histogram"</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"refresh"</span>:{" "}
                  <span className="jsonP">300</span>,
                </div>
                <div className="i1">
                  <span className="jsonG">"options"</span>: <span>&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonG">"responsive"</span>:{" "}
                  <span className="jsonP">true</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"title_display"</span>:{" "}
                  <span className="jsonP">false</span>
                </div>
                <div className="i1">
                  <span>&#125;,</span>
                </div>
                <div className="i1">
                  <span className="jsonG">"legend"</span>: <span>&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonG">"font_color"</span>:{" "}
                  <span className="jsonY">"#000000"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"position"</span>:{" "}
                  <span className="jsonY">"top"</span>,
                </div>
                <div className="i2">
                  <span className="jsonG">"display"</span>:{" "}
                  <span className="jsonP">true</span>
                </div>
                <div className="i1">
                  <span>&#125;,</span>
                </div>
                <div className="i1">
                  <span className="jsonG">"data_feed"</span>:{" "}
                  <span>&#123;</span>
                </div>
                <div className="i2">
                  <span className="jsonG">"my_first_feed"</span>:{" "}
                  <span>&#123;</span>
                </div>
                <div className="i3">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>
                <div className="i3">
                  <span className="jsonG">"feeds"</span>: <span>&#123;</span>
                </div>
                <div className="i4">
                  <span className="jsonG">"created_records"</span>:{" "}
                  <span>&#123;</span>
                </div>
                <div className="i5">
                  <span className="jsonG">"title"</span>:{" "}
                  <span className="jsonY">"New Incidents"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"source_url_api"</span>:{" "}
                  <span className="jsonY">"incident"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"source_url_api_system_object"</span>:{" "}
                  <span className="jsonP">false</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"color_foreground"</span>:{" "}
                  <span className="jsonY">"#F44336"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"color_background"</span>:{" "}
                  <span className="jsonY">"rgba(244, 67, 54, 0.3)"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"datasets_json"</span>:{" "}
                  <span className="jsonY">"{'{\\"fill\\": true}'}"</span>,
                </div>
                <div className="i5">
                  <span className="jsonG">"order"</span>:{" "}
                  <span className="jsonP">1</span>,
                </div>

                <div className="i5">
                  <span className="jsonG">"query"</span>: <span>&#123;</span>
                </div>
                <div className="i6">
                  <span className="jsonG">"range"</span>: <span>&#123;</span>
                </div>
                <div className="i7">
                  <span className="jsonG">
                    "object_created_by.date_created"
                  </span>
                  : <span>&#123;</span>
                </div>

                <div className="i8">
                  <span className="jsonG">"gte"</span>:{" "}
                  <span className="jsonY">"now-30d/d"</span>,
                </div>
                <div className="i8">
                  <span className="jsonG">"lt"</span>:{" "}
                  <span className="jsonY">"now/d"</span>
                </div>

                <div className="i7">
                  <span>&#125;</span>
                </div>
                <div className="i6">
                  <span>&#125;</span>
                </div>
                <div className="i5">
                  <span>&#125;</span>,
                </div>

                <div className="i5">
                  <span className="jsonG">"aggs"</span>: <span>&#123;</span>
                </div>
                <div className="i6">
                  <span className="jsonG">"created"</span>: <span>&#123;</span>
                </div>
                <div className="i7">
                  <span className="jsonG">"date_histogram"</span>:{" "}
                  <span>&#123;</span>
                </div>

                <div className="i8">
                  <span className="jsonG">"field"</span>:{" "}
                  <span className="jsonY">
                    "object_created_by.date_created"
                  </span>
                  ,
                </div>
                <div className="i8">
                  <span className="jsonG">"interval"</span>:{" "}
                  <span className="jsonY">"day"</span>,
                </div>
                <div className="i8">
                  <span className="jsonG">"offset"</span>:{" "}
                  <span className="jsonY">"+1h"</span>
                </div>

                <div className="i7">
                  <span>&#125;</span>
                </div>
                <div className="i6">
                  <span>&#125;</span>
                </div>
                <div className="i5">
                  <span>&#125;</span>
                </div>

                <div className="i4">
                  <span>&#125;</span>
                </div>
                <div className="i3">
                  <span>&#125;</span>
                </div>
                <div className="i2">
                  <span>&#125;</span>
                </div>
                <div className="i1">
                  <span>&#125;</span>
                </div>
                <div>&#125;</div>
              </div>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default Component_dashboard_line_chart;



// WEBPACK FOOTER //
// ./src/components/knowlege/interface/Component_dashboard_line_chart.js